import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AppIntl from "./Components/Application/AppIntl.jsx";
import { ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";
import { injectStore } from "./Services/AxiosInterceptor.js";
import store from "./Features/Store.js";
import { FPACTTheme } from "react-common-ui-library";

injectStore(store);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
      <ThemeProvider theme={FPACTTheme}>
        <Provider store={store}>
          <AppIntl />
        </Provider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
